
// 注册 vant UI组件
import {
  Button,
  Tag,
  NavBar,
  Tabbar,
  TabbarItem,
  Grid,
  GridItem,
  Image,
  DropdownMenu,
  DropdownItem,
  Popover,
  Search,
  Col,
  Row,
  List,
  PullRefresh,
  Cell,
  Form,
  Field,
  CellGroup,
  Picker,
  Popup,
  Icon,
  Tab, 
  Tabs,
  Calendar,
  Radio,
  RadioGroup,
  Area,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup,
  Uploader,
  Step, 
  Steps,
  Toast,
  DatetimePicker,
  Dialog 
} from "vant";


export default (app) => {
  // 放入公共card组件 commonCard
  app
    .component(Button.name, Button)
    .component(Tag.name, Tag)
    .component(NavBar.name, NavBar)
    .component(Tabbar.name, Tabbar)
    .component(TabbarItem.name, TabbarItem)
    .component(Grid.name, Grid)
    .component(GridItem.name, GridItem)
    .component(Image.name, Image)
    .component(DropdownMenu.name, DropdownMenu)
    .component(DropdownItem.name, DropdownItem)
    .component(Popover.name, Popover)
    .component(Search.name, Search)
    .component(Col.name, Col)
    .component(Row.name, Row)
    .component(List.name, List)
    .component(PullRefresh.name, PullRefresh)
    .component(Cell.name, Cell)
    .component(Form.name, Form)
    .component(Field.name, Field)
    .component(CellGroup.name, CellGroup)
    .component(Picker.name, Picker)
    .component(Popup.name, Popup)
    .component(Icon.name, Icon)
    .component(Tab.name, Tab)
    .component(Tabs.name, Tabs)
    .component(Calendar.name, Calendar)
    .component(Radio.name, Radio)
    .component(RadioGroup.name, RadioGroup)
    .component(Area.name, Area)
    .component(Collapse.name, Collapse)
    .component(CollapseItem.name, CollapseItem)
    .component(Checkbox.name, Checkbox)
    .component(CheckboxGroup.name, CheckboxGroup)
    .component(Uploader.name, Uploader)
    .component(Step.name, Step)
    .component(Steps.name, Steps)
    .component(Toast.name, Toast)
    .component(DatetimePicker.name, DatetimePicker)
    .component(Dialog.name, Dialog)
};
